import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台介绍</h2>
          <p className="mt-2 text-sm text-foreground-500">了解51大赛平台</p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            {aboutContent.description}
          </p>
          <div className="mt-8 grid grid-cols-3 gap-4 md:gap-6 text-center">
            <div className="p-4 rounded-xl bg-background-100">
              <div className="text-xl md:text-2xl font-bold text-primary-500">156+</div>
              <div className="text-xs text-foreground-500 mt-1">经典赛事</div>
            </div>
            <div className="p-4 rounded-xl bg-background-100">
              <div className="text-xl md:text-2xl font-bold text-accent-500">48</div>
              <div className="text-xs text-foreground-500 mt-1">赛季视频合集</div>
            </div>
            <div className="p-4 rounded-xl bg-background-100">
              <div className="text-xl md:text-2xl font-bold text-secondary-600">每日</div>
              <div className="text-xs text-foreground-500 mt-1">内容更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}